<template>
  <div class="modal-backdrop pt-5">
    <div class="card maincard col-lg-4 col-md-8 mt-md-4 col-11 p-0 mx-auto" v-if="!displayAPIerrorModal">
      <div class="modal-content border-0">
        <div class="modal-header p-4">          
          <h5 class="modal-title fontsize16 black80 proximanova-bold ml-2" id="exampleModalLabel" v-if="selectedUserId == getuserid">Add Photo</h5>
          <h5 class="modal-title fontsize16 black80 proximanova-bold ml-2" id="exampleModalLabel" v-else>Profile Picture</h5>
          <button type="button" class="close" @click="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body bodymodal11 backgroundcolorblack">
          <vue-croppie ref="croppieRef" v-if="imgSelected" :enableOrientation="true" :boundary="{ width: 300, height: 300}" :viewport="{ width:250, height:250, 'type':'circle' }"></vue-croppie>
          <div class="profilecircle-padding" v-if="!imgSelected">
            <div class="profilecircle mx-auto" id="circle">
              <div class="grid">
                <div v-for="image in profileImage" :key="image">
                   <img :src="image" oncontextmenu="return false" id="profileImageDisplay" alt="image" class="grid">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-between">
          <div>
            <input type="file" class="form-control-file" id="imgfileUpload1"  multiple  accept="image/*" @change="onimgFileSelected"
                @click="chooseImgFiles()" hidden/>
            <button @click="chooseImgFiles()" class="text-center btn proximanova mouseoverbtn1 border borderradius20" v-if="selectedUserId == getuserid">Upload Photo</button>
          </div>
          <div>
            <button class="mr-3 btn mouseoverbtn1 border borderradius20" @click="close">
              <span class="proximanova" v-if="selectedUserId == getuserid">Cancel</span>
              <span class="proximanova" v-else>Close</span>
            </button>
            <img src="../assets/uploadvideo.svg" width="30px" class="img-fluid ml-1 mr-3" alt="uploading" v-if="uploadbuttonClicked && selectedUserId == getuserid">
            <button class="mr-3 btn backgroundcolorblack white mouseoverbtn2 borderradius20" id="uploadphoto" v-if="!uploadbuttonClicked && selectedUserId == getuserid" :disabled="uploadphoto" @click="onUpload">
              <span class="button-create-font proximanova">Upload</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card maincard col-lg-3 col-md-5 mt-md-4 col-10 p-0 borderadius12 mx-auto" v-else>
      <div class="modal-content border-0 borderadius12">
        <div class="modal-body p-5 pb-5">
          <div class="d-flex flex-column text-center">
            <!-- <span class="proximanova-bold fontsize18 black">Error</span> -->
            <span class="mt-2 proximanova fontsize18 black">Something Went Wrong</span>
            <span class="mt-1 proximanova fontsize16 black60">Sorry, something went wrong there. Try again later.</span>
            <button class="backgroundcolor3 white bordernone proximanova mouseoverbtn1 mt-4 p-1 borderadius12" @click="close()" data-dismiss="modal" aria-label="Close">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
// import httpuserprofile from "@/js/http-userprofile.js";
import httpuserprofile from "@/js/http-userprofile.js"
import sessionUtils from '@/js/session-util.js'
import $ from "jquery";
export default{
   data() {
    return{
        profileImage : [],
        imgSelected : false,
        uploadphoto : true,
        croppieImage: '',
        cropped: null,
        getuserid : null,
        selectedUserId : null,
        uploadbuttonClicked : false,
        statusObj : {
          status : 'NOTSUCCESS'
        },
        displayAPIerrorModal : false,
    }
  },
  props:[
    'profilePictureObj'
  ],
  methods:{
    //this will invoke after click on close/cancel button or successfully saved company logo
    close() {
        this.$emit('closeProfilePhotoModal', this.statusObj);
    },
    //this will invoke after click on upload photo button
    chooseImgFiles() {
        document.getElementById("imgfileUpload1").click()
    },
    onimgFileSelected(event){
      console.log("image selected")
      this.profileImage = [];
      this.imgSelected = true;
      let that = this;
      let fileList = Array.prototype.slice.call(event.target.files);
      fileList.forEach(f => {
        if(!f.type.match("image.*")) {
  				return;
	  		}
        let reader = new FileReader();
        reader.onload = function (event) {
          that.profileImage.push(event.target.result)
          //bind image as reference for vue-cropper
          that.$refs.croppieRef.bind({
            url: event.target.result
          });
        }
        reader.readAsDataURL(f);         
        this.uploadphoto = false
        // document.getElementById("uploadphoto").classList.add("sign-in-button");
      });
      console.log(this.profileImage)      
    },
    //this will invoke after click on upload button
    onUpload(){
      this.uploadbuttonClicked = true;
      let that  = this;
      let options = {        
        format: 'jpeg',
        circle: false, 
        type: 'canvas',
        size : 'original',
        quality : 0.2
      };
      //get crapped image source from vue-cropper ref
      this.$refs.croppieRef.result(options, output => {
        this.cropped = this.croppieImage = output;      
          const fd = new FormData();
          var image = DataURIToBlob(this.croppieImage)
          fd.append('profilePicture', image);
          console.log(image)
          httpuserprofile.post("/userprofile/uploadProfilepicture/"+that.getuserid,fd, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
          })
          .then(res=>{
            this.statusObj.status = 'SUCCESS'
            this.uploadbuttonClicked = false;
            this.close()
            console.log(res)
          }).catch((e) => {
            console.log(e)
            this.uploadbuttonClicked = false;
            this.displayAPIerrorModal = true;
            setTimeout(() => {
              that.close() 
            }, 5000);
          })
      });
        function DataURIToBlob(dataURI) {
          const splitDataURI = dataURI.split(',')
          const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
          const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

          const ia = new Uint8Array(byteString.length)
          for (let i = 0; i < byteString.length; i++)
              ia[i] = byteString.charCodeAt(i)

          return new Blob([ia], { type: mimeString })
        }      
    },
  },
   mounted() {
     this.getuserid = sessionUtils.getUserId()
     this.selectedUserId = this.profilePictureObj.userId;
      // console.log(this.profilePictureObj)
      this.profileImage.push(this.profilePictureObj.profilepictureLink)
  },

}

</script>

<style>
@import '../css/croppie.css';
@import '../css/modal.css';
.maincard {
  width: 420px;
}
</style>